import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfCalendarioAdmin } from '@/modules/Administracion/interfaces'
import type { AxiosResponse } from 'axios'
import type { IResponseApi } from '@/modules/Core/interfaces'
export class CalendarioAdminService extends BaseService<IConfCalendarioAdmin> {
  constructor () {
    super({
      baseUrl: 'system/calendarioadmin/'
    })
  }
  async createFestivos<T> (
    data: T
  ): Promise<AxiosResponse<IResponseApi<T>>> {
    return this.http.post<T>(`/create-festivos`, data).catch(this.errorHandle)
  }
}
